// @flow
import React from "react";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import styles from "./SalesDetails.scss";
import TabularData from "./TabularData";

type Props = {
  pendingItem: Object,
  currencyCode: string,
  commissionData: Object,
  saleData: Object,
  penaltyData: Object,
  subheader: string,
  deltaEnabled: boolean
};
const SalesOverview = (props: Props) => {
  const {
    pendingItem,
    currencyCode,
    deltaEnabled,
    commissionData,
    saleData,
    subheader,
    penaltyData
  } = props;
  return pendingItem ? (
    <div className={styles.details}>
      <div className={`${styles.flexRow} ${styles.tableHead}`}>
        {saleData ? <TabularData data={saleData} /> : ""}
        {commissionData ? <TabularData data={commissionData} /> : ""}
        {penaltyData ? <TabularData data={penaltyData} penalty={true} /> : ""}
      </div>
      <div className={styles.flexRow}>
        <TabularData data={{ header: subheader }} />
      </div>
      <div className={styles.mainDetails}>
        {deltaEnabled ? (
          <div className={styles.flexRow}>
            <div className={styles.label} />
            <div className={styles.spacerDiv} style={{ border: "none" }} />
            <div className={`${styles.label} ${styles.value}`}>
              {I18n.getText("sales.current-due")}
              <div className={styles.delta}>{I18n.getText("sales.change")}</div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className={styles.flexRow}>
          <div className={styles.mainlabel}>
            {I18n.getText("sales.base-price")}
          </div>
          <div className={styles.spacerDiv} />
          <div
            className={`${styles.mainlabel} ${
              deltaEnabled ? styles.value : ""
            }`}
          >
            {I18n.formatCurrency(
              Helper.formatPrice(
                pendingItem.delivered_base_price ||
                  pendingItem.target_base_price,
                currencyCode
              )
            )}
            {deltaEnabled ? (
              <div
                className={`${styles.delta}
                ${
                  pendingItem.delta_base_price > 0
                    ? styles.positive
                    : pendingItem.delta_base_price < 0 ? styles.negative : ""
                }`}
              >
                {pendingItem.delta_base_price &&
                pendingItem.delta_base_price !== 0
                  ? I18n.formatCurrency(
                      Helper.formatPrice(
                        pendingItem.delta_base_price,
                        currencyCode
                      )
                    )
                  : "-"}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className={styles.flexRow}>
          <div className={styles.label}>
            {I18n.getText("sales.seller-promo")}
          </div>
          <div className={styles.spacerDiv} />
          <div
            className={`${styles.label} ${deltaEnabled ? styles.value : ""}`}
          >
            {I18n.formatCurrency(
              Helper.formatPrice(pendingItem.seller_promo, currencyCode)
            )}
            {deltaEnabled ? <div className={styles.delta}>-</div> : ""}
          </div>
        </div>
        <div className={styles.flexRow}>
          <div className={styles.mainlabel}>
            {I18n.getText("sales.seller-price")}
          </div>
          <div className={styles.spacerDiv} />
          <div
            className={`${styles.mainlabel} ${
              deltaEnabled ? styles.value : ""
            }`}
          >
            {I18n.formatCurrency(
              Helper.formatPrice(pendingItem.seller_price, currencyCode)
            )}
            {deltaEnabled ? <div className={styles.delta}>-</div> : ""}
          </div>
        </div>
        <div className={styles.flexRow}>
          <div className={styles.label}>
            {I18n.getText("sales.noon-markup")}
          </div>
          <div className={styles.spacerDiv} />
          <div
            className={`${styles.label} ${deltaEnabled ? styles.value : ""}`}
          >
            {I18n.formatCurrency(
              Helper.formatPrice(pendingItem.noon_markup, currencyCode)
            )}
            {deltaEnabled ? <div className={styles.delta}>-</div> : ""}
          </div>
        </div>
        <div className={styles.flexRow}>
          <div className={styles.label}>{I18n.getText("sales.deal-promo")}</div>
          <div className={styles.spacerDiv} />
          <div
            className={`${styles.label} ${deltaEnabled ? styles.value : ""}`}
          >
            {I18n.formatCurrency(
              Helper.formatPrice(pendingItem.promo_deal, currencyCode)
            )}
            {deltaEnabled ? <div className={styles.delta}>-</div> : ""}
          </div>
        </div>
        <div className={styles.flexRow}>
          <div className={styles.mainlabel}>
            {I18n.getText("sales.offer-price")}
          </div>
          <div className={styles.spacerDiv} />
          <div
            className={`${styles.mainlabel} ${
              deltaEnabled ? styles.value : ""
            }`}
          >
            {I18n.formatCurrency(
              Helper.formatPrice(pendingItem.offer_price, currencyCode)
            )}
            {deltaEnabled ? <div className={styles.delta}>-</div> : ""}
          </div>
        </div>
        <div className={styles.flexRow}>
          <div className={styles.label}>
            {I18n.getText("sales.coupon-promo")}
          </div>
          <div className={styles.spacerDiv} />
          <div
            className={`${styles.label} ${deltaEnabled ? styles.value : ""}`}
          >
            {I18n.formatCurrency(
              Helper.formatPrice(pendingItem.promo_coupon, currencyCode)
            )}
            {deltaEnabled ? <div className={styles.delta}>-</div> : ""}
          </div>
        </div>
        <div className={styles.flexRow}>
          <div className={styles.label}>
            {I18n.getText("sales.indirect-vat")}
          </div>
          <div className={styles.spacerDiv} />
          <div
            className={`${styles.label} ${deltaEnabled ? styles.value : ""}`}
          >
            {I18n.formatCurrency(
              Helper.formatPrice(pendingItem.indirect_vat, currencyCode)
            )}
            {deltaEnabled ? <div className={styles.delta}>-</div> : ""}
          </div>
        </div>
        <div className={styles.flexRow}>
          <div className={styles.mainlabel}>
            {I18n.getText("sales.invoice-price")}
          </div>
          <div className={styles.spacerDiv} />
          <div
            className={`${styles.mainlabel} ${
              deltaEnabled ? styles.value : ""
            }`}
          >
            {I18n.formatCurrency(
              Helper.formatPrice(
                pendingItem.delivered_invoice_price ||
                  pendingItem.invoice_price ||
                  pendingItem.target_invoice_price,
                currencyCode
              )
            )}
            {deltaEnabled ? (
              <div
                className={`${styles.delta}
                ${
                  pendingItem.delta_invoice_price > 0
                    ? styles.positive
                    : pendingItem.delta_invoice_price < 0 ? styles.negative : ""
                }`}
              >
                {pendingItem.delta_invoice_price &&
                pendingItem.delta_invoice_price !== 0
                  ? I18n.formatCurrency(
                      Helper.formatPrice(
                        pendingItem.delta_invoice_price,
                        currencyCode
                      )
                    )
                  : "-"}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {pendingItem.fees && pendingItem.fees.length
          ? pendingItem.fees.map((fee, idx) => {
              return fee.amount || fee.target_amount || fee.delta_amount ? (
                <div key={idx} className={styles.flexRow}>
                  <div className={styles.label}>{fee.fee_name}</div>
                  <div className={styles.spacerDiv} />
                  <div
                    className={`${styles.label} ${
                      deltaEnabled ? styles.value : ""
                    }`}
                  >
                    {I18n.formatCurrency(
                      Helper.formatPrice(
                        fee.amount || fee.target_amount,
                        currencyCode
                      )
                    )}
                    {deltaEnabled ? (
                      <div
                        className={`${styles.delta}
                      ${
                        fee.delta_amount > 0
                          ? styles.positive
                          : fee.delta_amount < 0 ? styles.negative : ""
                      }`}
                      >
                        {fee.delta_amount && fee.delta_amount !== 0
                          ? I18n.formatCurrency(
                              Helper.formatPrice(fee.delta_amount, currencyCode)
                            )
                          : "-"}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : (
                ""
              );
            })
          : ""}
      </div>
      <div className={styles.mainDetails}>
        <div className={styles.flexRow}>
          <div className={styles.netLabel}>{I18n.getText("sales.net-due")}</div>

          <div
            className={`${styles.netVal} ${deltaEnabled ? styles.value : ""}`}
          >
            {I18n.formatCurrency(
              Helper.formatPrice(
                pendingItem.delivered_net_due || pendingItem.target_net_due,
                currencyCode
              )
            )}
            {deltaEnabled ? (
              <div
                className={`${styles.delta}
                ${
                  pendingItem.delta_net_due > 0
                    ? styles.positive
                    : pendingItem.delta_net_due < 0 ? styles.negative : ""
                }`}
              >
                {pendingItem.delta_net_due && pendingItem.delta_net_due !== 0
                  ? I18n.formatCurrency(
                      Helper.formatPrice(
                        pendingItem.delta_net_due,
                        currencyCode
                      )
                    )
                  : "-"}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};
export default SalesOverview;



// WEBPACK FOOTER //
// ./src/components/sales/salesDetails/SalesOverview.js